import dayjs from 'dayjs'
import constants from '../constants'

class Utils {
  formatHHMM (hhmm) {
    if (!hhmm) return '(未設定)'
    return hhmm.substr(0, 2) + ':' + hhmm.substr(2, 2)
  }

  formatDay (day) {
    if (!day) return day
    return dayjs(day).format('YYYY-MM-DD')
  }

  genStaffName (staff) {
    if (!staff) return ''
    return staff.display_name_kana ? `${staff.display_name}(${staff.display_name_kana})` : staff.display_name
  }

  getUserName (user) {
    if (!user) return ''
    return user.display_name_kana ? `${user.display_name}(${user.display_name_kana})` : user.display_name
  }

  getEventColor (plan) {
    const status = plan.plan_status_cd
    if (status === constants.Code.PlanStatus.APPROVED) {
      return constants.StatusColors.APPROVED
    } else if (status >= constants.Code.PlanStatus.DYNAMIC_REPORTED) {
      return constants.StatusColors.REPORTE_COMPLETED
    } else if (status >= constants.Code.PlanStatus.REPORTED) {
      return constants.StatusColors.REPORTED
    }
    return constants.StatusColors.DEFAULT
  }

  covert2Dayjs (dateStr, format) {
    if (!dateStr) return null
    return dayjs(dateStr, format)
  }

  /**
   * シフト表などで用いるスタッフの並び（ふりがな → 表示名、アイウエオ順）
   * @param {Array} staffs
   * @returns {Array}
   */
  sortStaffsByKana (staffs) {
    if (!staffs || !staffs.length) return []
    return [...staffs].sort((a, b) => {
      const ka = (a.display_name_kana || '').toLowerCase()
      const kb = (b.display_name_kana || '').toLowerCase()
      const byKana = ka.localeCompare(kb, 'ja')
      if (byKana !== 0) return byKana
      return (a.display_name || '').localeCompare(b.display_name || '', 'ja')
    })
  }
}

export default new Utils()
